import { createSlice, nanoid } from "@reduxjs/toolkit";

const initialState = {
  boards: [
    { id: "b1", projectId: "p1", title: "To Do", order: 1 },
    { id: "b2", projectId: "p1", title: "In Progress", order: 2 },
    { id: "b3", projectId: "p1", title: "Done", order: 3 },
  ],
};

const boardsSlice = createSlice({
  name: "boards",
  initialState,
  reducers: {
    addBoard: {
      reducer(state, action) {
        state.boards.push(action.payload);
      },
      prepare({ projectId, title }) {
        return {
          payload: {
            id: nanoid(),
            projectId,
            title,
            hasTaskBefore: false,
            order: Date.now(),
          },
        };
      },
    },
    updateBoard(state, action) {
      const { id, updates } = action.payload;
      const index = state.boards.findIndex((b) => b.id === id);
      if (index !== -1) {
        state.boards[index] = { ...state.boards[index], ...updates };
      }
    },
    deleteBoard(state, action) {
      const id = action.payload;
      state.boards = state.boards.filter((b) => b.id !== id);
    },
  },
});

export const { addBoard, updateBoard, deleteBoard } = boardsSlice.actions;
export default boardsSlice.reducer;
